export default __webpack_public_path__ + "static/media/poi_hospital_multi.f369ce8a.svg";